import React from 'react'
import PropTypes from "prop-types";
import {
   Dropdown
} from 'semantic-ui-react'

class InputElement extends React.Component {


   static propTypes = {
      title: PropTypes.string,
      description: PropTypes.string,
      name: PropTypes.string,
      className: PropTypes.string,
      inputType: PropTypes.string,
      options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array]),
      checked: PropTypes.bool,
      ref: PropTypes.node,
      isRequired: PropTypes.bool,
      isSearchable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
      isMultiple: PropTypes.bool,
      isDeburr: PropTypes.bool,
      needsLabel: PropTypes.bool,
      needsFocus: PropTypes.bool,
      needsAutoFocus: PropTypes.bool,
      closeOnBlur: PropTypes.bool,
      selectOnBlur: PropTypes.bool,
      hasError: PropTypes.object,
      errorMsg: PropTypes.string,
      noResultsMessage: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onSearchChange: PropTypes.func,
      onKeyDown: PropTypes.func,
      refName: PropTypes.string,
   };

   componentDidUpdate(prevProps) {
      if (prevProps.needsFocus !== this.props.needsFocus) {
         if (this.props.needsFocus && this.props.refName) {
            this.refs[this.props.refName].focus();
         }
      }
   }

   render() {

      let inputComp;
      let labelComp;
      let requiredMsgComp;
      let errorLabelClass;
      let errorInputClass;
      let showError = false;
      let errorMsg;

      if (this.props.needsLabel && this.props.title) {
         labelComp = (
            <label>{this.props.title}</label>
         );
      }

      if (this.props.isRequired) {

         if (this.props.hasError[this.props.name] && this.props.errorMsg) {
            errorLabelClass = 'visible';
            errorInputClass = 'error';
            showError = true;
            errorMsg = this.props.errorMsg;
         }

         requiredMsgComp = (
            <div className={"input-error-msg " + errorLabelClass}>{errorMsg}</div>
         );
      }

      if (this.props.inputType === "text") {
         inputComp = (
            <input
               type="text"
               placeholder={this.props.title}
               name={this.props.name}
               value={this.props.value}
               className={this.props.className + " " + errorInputClass}
               onBlur={this.props.onBlur}
               onChange={this.props.onChange}
               onKeyDown={this.props.onKeyDown}
               ref={this.props.refName}
               autoFocus={this.props.needsAutoFocus}
            />
         );
      } else if (this.props.inputType === "checkbox") {
         inputComp = (
            <div className="checkbox_container">
               <input
                  type="checkbox"
                  id={this.props.name}
                  name={this.props.name}
                  defaultChecked={this.props.checked}
                  className={this.props.className + " " + errorInputClass}
                  onBlur={this.props.onBlur}
                  onChange={this.props.onChange}
               />
               <label
                  htmlFor={this.props.name}
                  className="checkbox_label">
                  <div>{this.props.title}</div>
                  <span className="light">{this.props.description}</span>
               </label>
            </div>
         );
      } else if (this.props.inputType === "dropdown") {
         inputComp = (
            <Dropdown
   				placeholder={this.props.title}
   				fluid
   				selection
               defaultValue={this.props.value}
               noResultsMessage={this.props.noResultsMessage}
               multiple={this.props.isMultiple}
               search={this.props.isSearchable}
               deburr={this.props.isDeburr}
   				error={showError}
   				options={this.props.options}
               onBlur={this.props.onBlur}
               closeOnBlur={this.props.closeOnBlur}
               selectOnBlur={this.props.selectOnBlur}
               onChange={this.props.onChange}
               onSearchChange={this.props.onSearchChange}
   			/>
         );
      } else if (this.props.inputType === "textarea") {
         inputComp = (
            <textarea
               placeholder={this.props.title}
               name={this.props.name}
               className={this.props.className + " " + errorInputClass}
               onBlur={this.props.onBlur}
               onChange={this.props.onChange}
               onKeyDown={this.props.onKeyDown}
               value={this.props.value}
               ref={this.props.refName}
               autoFocus={this.props.needsAutoFocus}
            ></textarea>
         );
      }

      return (
         <div>
            {labelComp}
            {inputComp}
            {requiredMsgComp}
         </div>
      );
   }

};

export default InputElement



// WEBPACK FOOTER //
// ./src/components/FormElements/InputElement.js